/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceType } from '../models/ResourceType';
import { StandardBackupSchedules } from '../models/StandardBackupSchedules';

export class StandardBackupPolicyPlan {
  /**
  * Resource types to back up.
  */
  'resourceTypes'?: Array<ResourceType>;
  /**
  * List of backup schedules. Each schedule specifies a backup frequency, retention period, and vault. 
  */
  'backupSchedules': Array<StandardBackupSchedules>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceTypes",
      "baseName": "resourceTypes",
      "type": "Array<ResourceType>",
      "format": ""
    },
    {
      "name": "backupSchedules",
      "baseName": "backupSchedules",
      "type": "Array<StandardBackupSchedules>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StandardBackupPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}

